import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=332e214a&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"
import style0 from "./ListItems.vue?vue&type=style&index=0&id=332e214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e214a",
  null
  
)

export default component.exports